/**
 * Public theme entry point for shared components.
 *
 * 1. Export theme creation and custom theme types.
 * 2. Export light and dark options and semantic tokens.
 * 3. Export reusable surface builders.
 * Continues in `surfaces.ts`, which implements the CSS surface values.
 */
export { createTheme } from './createTheme';

// Export all custom types
/**
 * This makes it so consumers of this theme automatically get the updated types for the theme.
 */
export type { Theme, ThemeOptions } from './customTypes/theme';
export type { AlertProps, AlertColor } from './customTypes/alert';
export type { ButtonPropsVariantOverrides, ButtonPropsColorOverrides } from './customTypes/button';
export type { CheckboxPropsSizeOverrides } from './customTypes/checkbox';
export type { TypographyPropsVariantOverrides, CustomTypographyVariant } from './customTypes/typography';

export { lightThemeOptions } from './light';
export { darkThemeOptions } from './dark';
export { palette } from './palette/light';
export { typography } from './typography';

/** Names the supported shared theme modes. */
export enum ThemeNames {
  LIGHT = 'light',
  DARK = 'dark',
}

export {
  getAgentSparkleIconDataUri,
  getPaperFadeMaskImage,
  getPrimaryAccentBackground,
  getPrimaryAccentContrastText,
  getPrimaryAccentTextGradient,
  getPrimaryHeroGradient,
  getPrimaryTintFadeBackground,
  getPrimaryTintPaperGradient,
  getPrimaryTintSurface,
  getTintOverDefaultBackground,
  getSkeletonShimmerBackground,
  getSuccessHeroGradient,
} from './surfaces';
